module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/4/4-f5ce11fe1b223175b760db8cb17fd56e.jpg";